import { createStructuredSelector, createSelector } from "reselect";
import { workareaSelector } from "features/workarea/selectors";
import { organizationSelector } from "features/organization/selectors";

export const isFetchingSelector = state =>
  state.ctd.getIn(["upload", "isFetching"]);

export const rawFiles = state => state.ctd.getIn(["upload", "rawFiles"]);
export const rawFilesSelector = createSelector(
  rawFiles,
  x => x && x.toJS().map(f => ({ ...f, id: `${f.name}.${f.ext}` }))
);

export const filesUploadingSelector = createSelector(rawFilesSelector, rF =>
  rF.map(x => x.status).includes("pending")
);

export const hasStaticCastsSelector = state =>
  state.ctd.getIn(["upload", "hasStaticCasts"]);

export default createStructuredSelector({
  rawFiles: rawFilesSelector,
  filesUploading: filesUploadingSelector,
  isFetching: isFetchingSelector,
  hasStaticCasts: hasStaticCastsSelector,
  workarea: workareaSelector,
  organization: organizationSelector
});
